export default {
  methods: {
    phoneMask(event) {
      let formattedInputValue = '+7 ('

      const getInputNumbersValue = function (value) {
        return value.replace(/\D/g, '')
      }

      const pos = event.target.selectionStart

      const inputNumbersValue = getInputNumbersValue(String(this.inputValue))

      if (!inputNumbersValue) {
        return (this.inputValue = '+7 (')
      }

      if (String(this.inputValue).length !== pos) {
        if (event.data && /\D/g.test(event.data)) {
          this.inputValue = inputNumbersValue
        }
        return
      }

      formattedInputValue += inputNumbersValue.substring(1, 4)
      if (inputNumbersValue.length >= 4) {
        formattedInputValue += ') ' + inputNumbersValue.substring(4, 7)
      }
      if (inputNumbersValue.length >= 7) {
        formattedInputValue += '-' + inputNumbersValue.substring(7, 9)
      }
      if (inputNumbersValue.length >= 9) {
        formattedInputValue += '-' + inputNumbersValue.substring(9, 11)
      }

      this.inputValue = formattedInputValue
    },
  },
}
